export default {
  install(app) {
    // 操作成功时的提示消息
    app.config.globalProperties.$notifySucceed = function(msg) {
      // 这里假设你使用的通知库支持 this.$notify
      this.$notify({
        title: "成功",
        message: msg,
        type: "success",
        duration: 1000
      });
    };

    // 操作失败时的提示消息
    app.config.globalProperties.$notifyWarning = function(msg) {
      this.$notify({
        title: "警告",
        message: msg,
        type: "warning",
        duration: 1000
      });
    };
  }
}
